export default __webpack_public_path__ + "static/media/etape2_find.b5859f73.webp";